module.exports = __webpack_public_path__ + "img/2.4a3f4989.png";